import React from 'react';
import { Link } from 'react-router-dom';
import CatalogImage from '../catalog/CatalogImage';

/** Top-level category card on /shop */
export default function ShopCategoryCard({ to, image, name, description, countLabel }) {
  return (
    <Link to={to} className="shop-category-card shop-category-card--v2">
      <div className="shop-category-card__media">
        <CatalogImage
          src={image}
          className="shop-category-card__img"
          alt={name}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        />
        <span className="shop-category-card__cta">Explore</span>
      </div>
      <div className="shop-category-card__body">
        <h3 className="shop-category-card__title">{name}</h3>
        <p className="shop-category-card__desc">{description}</p>
        {countLabel ? <span className="shop-category-card__count">{countLabel}</span> : null}
      </div>
    </Link>
  );
}
